// extracted by mini-css-extract-plugin
module.exports = {"menubar":"LayoutStyle_menubar__1_XHX","sidenav":"LayoutStyle_sidenav__FDUZb","selected":"LayoutStyle_selected__1GpHs"};